import cAdImage from './AdImage'
export const AdImage = cAdImage
import cAdCard from './AdCard'
export const AdCard = cAdCard
